// extracted by mini-css-extract-plugin
export var chevron = "_ge-2";
export var dropdownItems = "_ge-0";
export var item = "_ge-1";